import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/cn'
import { SectionLabel } from '@/components/ui/Card'
import type { CategoryCount } from '@/lib/useStorefrontCategories'

/**
 * Category rail for the storefront. Deliberately does NOT use `.side-menu-link`
 * - that recipe is white-on-blue for the portal sidebar and is invisible on the
 * storefront's light field. These use the storefront chip recipe instead.
 */
export default function CategorySidebar({
  categories,
  total,
  value,
  onChange,
}: {
  categories: CategoryCount[]
  total: number
  value: string | null
  onChange: (next: string | null) => void
}) {
  const rows: { key: string; label: string; count: number; slug: string | null }[] = [
    { key: '__all', label: 'All products', count: total, slug: null },
    ...categories.map((c) => ({ key: c.name, label: c.name, count: c.count, slug: c.name })),
  ]

  return (
    <div className="box p-3">
      <SectionLabel className="px-2 text-sm">Categories</SectionLabel>
      <nav className="flex flex-col gap-0.5">
        {rows.map((row) => {
          const active = value === row.slug
          return (
            <button
              key={row.key}
              type="button"
              onClick={() => onChange(row.slug)}
              aria-current={active ? 'true' : undefined}
              className={cn(
                'flex items-center gap-2 rounded-lg border px-3 py-2 text-left text-sm transition-colors',
                active
                  ? 'border-transparent bg-foreground/5 font-bold text-foreground'
                  : 'border-transparent text-foreground/70 hover:bg-foreground/5',
              )}
            >
              <span className="flex-1 truncate">{row.label}</span>
              <span className={cn('text-xs tabular-nums', active ? 'text-foreground/50' : 'text-foreground/40')}>
                {row.count}
              </span>
              <ChevronRight className={cn('size-3.5 shrink-0 text-foreground/40', active ? 'opacity-100' : 'opacity-0')} />
            </button>
          )
        })}
      </nav>
    </div>
  )
}
